// @ts-check

import { format } from 'date-fns'
import { ocrState } from './utils'

/** @returns {EntryModuleState}  */
export const initAssignmentState = () => ({
  id: null,
  type: null,
  date: format(new Date(), 'yyyy-MM-dd'),
  description: '',
  items: [],

  files: [],
  paymentReductions: [],
  hasPaymentReductions: false,

  ocrState: ocrState.IDLE,
  ocrData: null,

  supplier: {
    country: 'finland',
    type: 'company',
    name: null,
    businessId: null,
    existingId: null
  },

  entry: null
})

export default initAssignmentState
